import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';

@Component({
    selector: 'pcg-action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss'],
    standalone: false
})
export class ActionButtonComponent implements OnInit {
	//Relative path to the image for the icon
	@Input() imgUrl: string;
	@Input() apiUrl: string;
	@Input() altText: string;
	@Input() recordId: number;
	@Output() updateTable = new EventEmitter<any>();

	subscriptions: Subscription = new Subscription();

	constructor(private httpClient: HttpClient) {}

	ngOnInit() {}

	actionClicked() {
		let params = new HttpParams().set('id', this.recordId.toString());
		this.subscriptions.add(
			this.httpClient.get(this.apiUrl, { params: params }).subscribe(_ => {
				this.updateTable.emit();
			})
		);
	}
}
